import { Box, useTheme } from "@mui/material";

import { hexToRgba } from "@aclymatepackages/converters";

import { AnimatedLogo } from "@aclymatepackages/atoms";

const LoadingCardLayoutBox = ({
  isLoading,
  backgroundColor = "white",
  children,
  style = {},
  ...otherProps
}) => {
  const { palette } = useTheme();

  return (
    <Box
      id="card-layout-box"
      p={3}
      style={{
        backgroundColor: backgroundColor
          ? hexToRgba(backgroundColor, 0.1)
          : palette.backgroundGray.light,
        ...style
      }}
      {...otherProps}
    >
      {isLoading ? (
        <Box
          display="flex"
          alignItems="center"
          justifyContent="center"
          style={{ height: "100%", width: "100%" }}
        >
          <AnimatedLogo />
        </Box>
      ) : (
        children
      )}
    </Box>
  );
};
export default LoadingCardLayoutBox;
